import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { Box, IconButton, Typography } from "@mui/material";
import TooltipWrapper from "../../../../../../components/TooltipWrapper.tsx";
import { Maybe } from "../../../../../../types.ts";

interface Props {
  customFieldValue: Maybe<string>;
  originalFieldValue: string;
  readonly?: boolean;
  label: string;
  defaultLabel: string;
  shouldShowDefaultLabel: boolean;
  onRenameClick: () => void;
}
export default function ViewField({
  customFieldValue,
  originalFieldValue,
  onRenameClick,
  readonly,
  label,
  defaultLabel,
  shouldShowDefaultLabel,
}: Props) {
  return (
    <>
      <Box flex={1} overflow={"hidden"}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          <Box sx={{ gap: 0.75, width: "36px" }}>
            <Typography>{label}:</Typography>
          </Box>
          <Typography variant="subtitle1" component="span" noWrap>
            {customFieldValue || originalFieldValue}
          </Typography>
        </Box>
        {shouldShowDefaultLabel && (
          <Typography noWrap variant="caption">
            {defaultLabel} - {originalFieldValue}
          </Typography>
        )}
      </Box>
      {readonly !== true && (
        <TooltipWrapper title="Rename" placement="bottom">
          <IconButton onClick={onRenameClick}>
            <DriveFileRenameOutlineIcon sx={(theme) => ({ color: theme.palette.secondary.light })} />
          </IconButton>
        </TooltipWrapper>
      )}
    </>
  );
}
